import type { Alert } from '@detect/shared';
import { api, withTenant, type PaginatedResult } from './api';
import type { WithId } from './types';

/** Alerts API (M5 surface). List honors the single-equality-filter
 *  rule: exactly one of status / severity / resourceId. */
export const alertService = {
  list: (
    tenantId: string,
    params: {
      status?: string;
      severity?: string;
      resourceId?: string;
      limit?: number;
      startAfter?: string;
    } = {}
  ): Promise<PaginatedResult<WithId<Alert>>> =>
    api.getPaginated<WithId<Alert>>(withTenant('/alerts', tenantId, params)),

  get: (tenantId: string, id: string): Promise<WithId<Alert>> =>
    api.get<WithId<Alert>>(withTenant(`/alerts/${id}`, tenantId)),

  acknowledge: (
    tenantId: string,
    id: string,
    note?: string
  ): Promise<WithId<Alert>> =>
    api.post<WithId<Alert>>(
      withTenant(`/alerts/${id}/ack`, tenantId),
      note ? { note } : {}
    ),

  resolve: (tenantId: string, id: string, note?: string): Promise<WithId<Alert>> =>
    api.post<WithId<Alert>>(
      withTenant(`/alerts/${id}/resolve`, tenantId),
      note ? { note } : {}
    ),

  addNote: (tenantId: string, id: string, note: string): Promise<WithId<Alert>> =>
    api.post<WithId<Alert>>(withTenant(`/alerts/${id}/notes`, tenantId), { note }),
};
